module.exports = __webpack_public_path__ + "img/3.d6159d58.webp";